/**
 * Routes that show the Layout AppBar global client selector (Phase 14.3).
 * Independent ops pages (IG automation, campaigns form, etc.) stay off this list.
 */

const SYNC_URL_PREFIXES = [
  '/analytics',
  '/reports',
  '/ml-insights',
  '/posts',
  '/scheduling',
  '/gallery',
];

export function isGlobalClientSelectorRoute(pathname) {
  const path = pathname || '';
  if (path === '/' || path === '') return true;
  if (path.startsWith('/reports/model')) return false;
  return SYNC_URL_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}

/** Whether selecting a client should write ?client_id= on this route. */
export function shouldSyncClientIdInUrl(pathname) {
  const path = pathname || '';
  if (path.startsWith('/reports/model')) return false;
  if (path === '/' || path === '') return false;
  return SYNC_URL_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}
